import React, { useState } from 'react';
import {
  AppBar,
  Breadcrumbs,
  Divider,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from './LocalizationProvider';
// editado
const useStyles = makeStyles((theme) => ({
  desktopRoot: {
    height: '100%',
    display: 'flex',
  },
  mobileRoot: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  radiusMenu: {
    '&.MuiButtonBase-root-MuiListItemButton-root': {
      margin: '0px 15px 0px 15px',
      borderRadius: '10px',
    },
  },
  desktopDrawer: {
    '& .MuiListItemIcon-root': {
      color: '#fff',
    },
    '& .css-1nkxam0-MuiButtonBase-root-MuiListItemButton-root:hover': {
      backgroundColor: 'rgb(220 230 123 / 37%)',
    },
    '& .css-1nkxam0-MuiButtonBase-root-MuiListItemButton-root.Mui-selected': {
      backgroundColor: 'rgb(220 230 123 / 15%)',
    },
    '& .css-9mnaki.Mui-selected': {
      backgroundColor: 'rgb(220 230 123 / 15%)',
    },
    '& .css-9mnaki.Mui-selected:hover': {
      backgroundColor: 'rgb(220 230 123 / 37%)',
    },
    '& .MuiButtonBase-root .MuiListItemButton-root .MuiListItemButton-gutters .MuiListItemButton-root .MuiListItemButton-gutters': {
      backgroundColor: 'rgb(220 230 123 / 37%)',
    },
    '& .css-9mnaki:hover': {
      backgroundColor: 'rgb(220 230 123 / 37%)',
    },
    '& .css-9mnaki-MuiButtonBase-root-MuiListItemButton-root:hover': {
      backgroundColor: 'rgb(220 230 123 / 37%)',
    },
    '& .css-9mnaki-MuiButtonBase-root-MuiListItemButton-root.Mui-selected': {
      backgroundColor: 'rgb(220 230 123 / 15%)',
    },
    width: '400px',
    border: 0,
    backgroundColor: '#263238',
    color: '#fff',
  },
  mobileDrawer: {
    width: theme.dimensions.drawerWidthTablet,
    border: 0,
    color: '#fff',
    '& .MuiListItemIcon-root': {
      color: '#fff',
    },
    '& .css-1nkxam0-MuiButtonBase-root-MuiListItemButton-root:hover': {
      backgroundColor: 'rgb(220 230 123 / 37%)',
    },
    '& .css-1nkxam0-MuiButtonBase-root-MuiListItemButton-root.Mui-selected': {
      backgroundColor: 'rgb(220 230 123 / 15%)',
    },
    '& .css-9mnaki.Mui-selected': {
      backgroundColor: 'rgb(220 230 123 / 15%)',
    },
    '& .css-9mnaki.Mui-selected:hover': {
      backgroundColor: 'rgb(220 230 123 / 37%)',
    },
    backgroundColor: '#263238',
  },
  mobileToolbar: {
    zIndex: 1,
  },
  content: {
    flexGrow: 1,
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
}));

const scrollBarCSS = `
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background-color: #f0f0f0;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgb(205 220 57 / 50%);
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: rgb(205 220 57 / 90%);
  }
`;

const PageTitle = ({ breadcrumbs }) => {
  const theme = useTheme();
  const t = useTranslation();

  const desktop = useMediaQuery(theme.breakpoints.up('md'));

  if (desktop) {
    return (
      <Typography variant="h6" noWrap>{t(breadcrumbs[0])}</Typography>
    );
  }
  return (
    <Breadcrumbs>
      {breadcrumbs.slice(0, -1).map((breadcrumb) => (
        <Typography variant="h6" color="inherit" key={breadcrumb}>{t(breadcrumb)}</Typography>
      ))}
      <Typography variant="h6" color="textPrimary">{t(breadcrumbs[breadcrumbs.length - 1])}</Typography>
    </Breadcrumbs>
  );
};

const PageLayout = ({ menu, breadcrumbs, children }) => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();

  const desktop = useMediaQuery(theme.breakpoints.up('md'));

  const [openDrawer, setOpenDrawer] = useState(false);

  return desktop ? (
    <div className={classes.desktopRoot}>
      <style>{scrollBarCSS}</style>
      <Drawer
        variant="permanent"
        className={classes.desktopDrawer}
        classes={{ paper: classes.desktopDrawer }}
      >
        <Toolbar>
          <IconButton color="inherit" edge="start" sx={{ mr: 2 }} onClick={() => navigate('/')}>
            <ArrowBackIcon />
          </IconButton>
          <PageTitle breadcrumbs={breadcrumbs} />
        </Toolbar>
        <Divider />
        {menu}
      </Drawer>
      <div className={classes.content}>{children}</div>
    </div>
  ) : (
    <div className={classes.mobileRoot}>
      <Drawer
        variant="temporary"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        classes={{ paper: classes.mobileDrawer }}
      >
        {menu}
      </Drawer>
      <AppBar className={classes.mobileToolbar} position="static" color="inherit">
        <Toolbar>
          <IconButton color="inherit" edge="start" sx={{ mr: 2 }} onClick={() => setOpenDrawer(true)}>
            <MenuIcon />
          </IconButton>
          <PageTitle breadcrumbs={breadcrumbs} />
        </Toolbar>
      </AppBar>
      <div className={classes.content}>{children}</div>
    </div>
  );
};

export default PageLayout;
